import script from "./CreateView.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateView.vue?vue&type=script&setup=true&lang=js"

import "./CreateView.vue?vue&type=style&index=0&id=1c0bc236&lang=less"

const __exports__ = script;

export default __exports__